import {
  getBirdviewMyCriticalRequests,
  getBirdviewMyServiceRequests,
  getRequestsExtraInfo,
} from '../../../../api'
import { createSearchArray } from '../../../../utils/api'
import {
  getBirdviewWidgetPageParams,
  toBirdviewListSection,
  toBirdviewWidgetRequestItem,
} from '../../DashboardBirdview.utils.api'

import { toBirdviewRequestCountersExtra } from './useBirdviewRequestLoaders.utils'

export function useBirdviewRequestLoaders() {
  // Tags are decoration: an enrichment failure must not hide the rows that
  // loaded.
  async function getRequestsExtra(items) {
    if (items.length === 0) {
      return null
    }

    try {
      const { data } = await getRequestsExtraInfo(
        createSearchArray('id', items)
      )

      return data
    } catch {
      return null
    }
  }

  async function getMyCriticalRequestsSection(params) {
    const { data } = await getBirdviewMyCriticalRequests(
      getBirdviewWidgetPageParams(params)
    )

    return {
      ...toBirdviewListSection(data, toBirdviewWidgetRequestItem),
      extra: await getRequestsExtra(data.items),
    }
  }

  async function getMyServiceRequestsSection(params) {
    const { data } = await getBirdviewMyServiceRequests(
      getBirdviewWidgetPageParams(params)
    )

    return {
      ...toBirdviewListSection(data, toBirdviewWidgetRequestItem),
      extra: toBirdviewRequestCountersExtra(data.items),
    }
  }

  return {
    getMyCriticalRequestsSection,
    getMyServiceRequestsSection,
    getRequestsExtra,
  }
}
